import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, LogIn } from 'lucide-react';

interface AuthRequiredModalProps {
  isOpen: boolean;
  onClose: () => void;
  message?: string;
  returnTo: string;
}

export default function AuthRequiredModal({ isOpen, onClose, message, returnTo }: AuthRequiredModalProps) {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleLogin = () => {
    navigate('/auth', { state: { returnTo, message } });
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl max-w-md w-full p-6 text-center">
        <div className="bg-brand-light w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6">
          <Lock className="h-8 w-8 text-brand-teal" />
        </div>

        <h2 className="text-2xl font-bold text-gray-900 mb-4">
          Login Necessário
        </h2>

        <p className="text-gray-600 mb-8">
          {message || 'Para acessar este recurso, você precisa estar logado em sua conta.'}
        </p>

        <div className="flex gap-4">
          <button
            onClick={onClose}
            className="flex-1 px-6 py-3 border border-gray-300 rounded-xl hover:bg-gray-50 transition-colors"
          >
            Voltar
          </button>

          <button
            onClick={handleLogin}
            className="flex-1 bg-brand-teal text-white px-6 py-3 rounded-xl hover:bg-brand-teal/90 transition-colors flex items-center justify-center gap-2"
          >
            <LogIn className="h-5 w-5" />
            Fazer Login
          </button>
        </div>
      </div>
    </div>
  );
}